import { UnitListItemDto }  from './unitListItem.dto';

export class UnitListDto {
    public types!: UnitListItemDto[];
}